
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import prohelp from '@/crowd_fund/prohelp'
import headerBackTitle from '@/components/header/headerBackTitle'
export default {
components: {
Flexbox,
FlexboxItem,
XInput,
XButton,
prohelp,
XSwitch,
CheckIcon,
headerBackTitle
},
data () {
return {
navList:[
{text: '10', isActive: true},
{text: '20', isActive: false},
{text: '50', isActive: false},
{text: '100', isActive: false}
],
paydata:{
title:'',       //发票抬头
cdkey:'',       //纳税人识别码
tel:'',        //联系电话
mailAddress:'',  //邮寄地址
detailAddress:'', //详细地址
postalCode:''      
},
inputMoney:'',
anonymous:false,    //是否匿名支持
afr052:2,           //1为匿名2非匿名  接口需要
isagree:true,       //是否同意用户协议
isinvoice:false,    //是否有发票
invo:2,             //1需要发票2不需要
people:true,       //个人或者企业
titleType:1,        //0为单位抬头1为个人抬头
people1:false,
submitMonet:10,
orderno:'',
isLogin:true,     //未登录用户不允许匿名捐助、索要发票
noLoginUserId:'',     //未登录用户提交订单返回的userid
noLoginUserName:'社会帮扶网-匿名用户',     //未登录用户提交订单返回的username
fromHelpList:2,
chaNelCode:'zgshfp',   //渠道编号，通过渠道的取URL上的参数，没有默认为zgshfp;
ActChannel_strs_w:'',
ActChannel_strs_a:'',
}
},
mounted(){



this.ActChannel_strs_w =(this.$route.query.channelCode?('?channelCode='+this.$route.query.channelCode):'?channelCode='+this.chaNelCode)+(this.$route.query.ActCode?('&ActCode='+this.$route.query.ActCode):'');
this.ActChannel_strs_a =(this.$route.query.channelCode?('&channelCode='+this.$route.query.channelCode):'&channelCode='+this.chaNelCode)+(this.$route.query.ActCode?('&ActCode='+this.$route.query.ActCode):'');
if(!this.isWeixinCient()){

if(this.$route.params.zctoken=='null'||this.$route.params.zctoken==null||this.$route.params.zctoken=='undefined'||this.$route.params.zctoken=='(null)'||this.$route.params.zctoken==undefined){

this.isLogin=false;
}
if(this.$route.query.headImage){
if(this.$route.query.headImage!=""&&this.$route.query.headImage!="null"&&this.$route.query.headImage!="(null)"&&this.$route.query.headImage!=undefined&&this.$route.query.headImage!="undefined")
this.L("zcheadimgurl",this.$route.query.headImage)
this.fromHelpList=1;
}
}
},
methods: {
add0(str){
if(str>=10){
return str;
}else{
return '0'+str;
}
},
Gtime(Stime,Year,Month,Dat){
var date = new Date(Stime);
var Y = date.getFullYear() + Year;
var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + Month;
var D = date.getDate() ;
var h = date.getHours();
var m = date.getMinutes();
var s = date.getSeconds();

var Time = Y+M+this.add0(D)+ Dat+' '+this.add0(h) + ':'+this.add0(m) + ':'+this.add0(s)
return Time
},
GtimeNow(){
var s = new Date();
var yyyy=s.getFullYear();
var mm = s.getMonth()+1;
if(mm<10){
mm='0'+mm;
}
var queryZcUserid = s.getDate();
if(queryZcUserid<10){
queryZcUserid = '0'+queryZcUserid;
}

return yyyy+'-'+mm+'-'+queryZcUserid
},
enterprisechose () {

this.paydata.title = '';
this.paydata.cdkey = '';
this.paydata.tel = '';
this.paydata.mailAddress = '';
this.paydata.detailAddress = '';
this.paydata.postalCode = '';
if(this.people == false){
this.people = true
this.people1 = false
this.titleType = 1
}else{
this.people = false
this.people1 = true
this.titleType = 0
}
},

showpop2 () {
this.$refs.protocolcon.showpop()
},
ischose () {
if(this.anonymous == false){
this.anonymous = true
this.afr052 = 1

}else{
this.anonymous = false
this.afr052 = 2

}
},
isagreechose () {
if(this.isagree == false){
this.isagree = true
}else{
this.isagree = false
}
},
isinvoicechose () {
if(this.isinvoice == false){
this.isinvoice = true
this.invo = 1

}else{
this.isinvoice = false
this.invo = 2

}
},
activeFun(data) {
this.navList.forEach(function (obj) {
obj.isActive = false
})
data.isActive = true
this.inputMoney = ''
this.submitMonet = data.text

},
gopey () {
console.log('goPey():::::'+this.$route.params.zctoken)
var inputnum = /(^[0-9]*[1-9][0-9]*$)/.test(this.submitMonet);   
if(this.isagree == false){
this.showToast('','text','请阅读并同意用户协议！','20em','','')
}else if(this.invo == '1'){
if(this.titleType == 1){
if(this.paydata.title == ''){
this.showToast('','text','请填写发票抬头','20em','','')
}else if(this.paydata.cdkey == ''){
this.showToast('','text','请填写纳税人识别码','20em','','')
}else if(this.paydata.tel == ''){
this.showToast('','text','请填写联系电话','20em','','')
}else if(this.paydata.mailAddress == ''){
this.showToast('','text','请填写邮寄地址','20em','','')
}else if(this.paydata.detailAddress == ''){
this.showToast('','text','请填写详细地址','20em','','')
}else if(this.paydata.postalCode == ''){
this.showToast('','text','请填写邮政编码','20em','','')
}else{
if(inputnum==false){
this.showToast('','text','请输入整数金额','20em','','')
}else{
this.getorderno()
}
}
}else if(this.titleType == 0){
if(this.paydata.title == ''){
this.showToast('','text','请填写发票抬头','20em','','')
}else if(this.paydata.tel == ''){
this.showToast('','text','请填写联系电话','20em','','')
}else if(this.paydata.mailAddress == ''){
this.showToast('','text','请填写邮寄地址','20em','','')
}else if(this.paydata.detailAddress == ''){
this.showToast('','text','请填写详细地址','20em','','')
}else if(this.paydata.postalCode == ''){
this.showToast('','text','请填写邮政编码','20em','','')
}else{
if(inputnum==false){
this.showToast('','text','请输入整数金额','20em','','')
}else{
this.getorderno()
}
}
}
}else{
if(inputnum==false){
this.showToast('','text','请输入整数金额','20em','','')
}else{
if( (this.$route.params.zctoken=='null'|| this.$route.params.zctoken == undefined || this.$route.params.zctoken == 'undefined' || this.$route.params.zctoken == '' || this.$route.params.zctoken == null) && (!this.isWeixinCient()) ){
this.getorderno_niming()
}else{
this.getorderno()
}
}
}
},
getorderno_niming () {
let data = {
afr052:2,//未登录禁止匿名
invo:2,//未登录禁止发票
afq006:this.submitMonet,//金额
afq004:'1',
payType:'1',

sum:10000,
acr001:this.$route.params.id,
acr002:decodeURIComponent(this.$route.params.acr002),










}
if(this.isWeixinCient()){
data.terminalCode = 'wechat_pub';
data.channelCode = (this.$route.query.channelCode?this.$route.query.channelCode:this.chaNelCode);
data.activityId = (this.$route.query.ActCode?this.$route.query.ActCode:'');
}else{
data.terminalCode = 'app';
data.channelCode = (this.$route.query.channelCode?this.$route.query.channelCode:this.chaNelCode);
data.activityId = (this.$route.query.ActCode?this.$route.query.ActCode:'');
}
this.$https.post(this.BASE_URL+"cfs/zc/z008/saveAnonymity",data).then(res => {

if(res.data.status == 200){
this.orderno = res.data.result.orderno;
this.noLoginUserId = res.data.result.userId;
this.noLoginUserName = res.data.result.userName;

if(this.$route.params.isDt == 'isDt') {
this.dTDonate()
}else {
this.pay(this.orderno)
}
}else {
this.showToast('','text',res.data.message,'20em','','')
}
})
},
getorderno () {
let data = {
afr052:this.afr052,
afq006:this.submitMonet,
afq004:'1',
payType:'1',
sum:this.$route.params.sum,
acr001:this.$route.params.id,
acr002:decodeURIComponent(this.$route.params.acr002),
uus001:this.$route.params.zcuserid,

titleType:this.titleType,
title:this.paydata.title,
cdkey:this.paydata.cdkey,
tel :this.paydata.tel,
mailAddress:this.paydata.mailAddress,
detailAddress:this.paydata.detailAddress,
postalCode:this.paydata.postalCode,
invo:this.invo
}
if(this.isWeixinCient()){
data.terminalCode = 'wechat_pub';
data.channelCode = (this.$route.query.channelCode?this.$route.query.channelCode:this.chaNelCode);
data.activityId = (this.$route.query.ActCode?this.$route.query.ActCode:'');
}else{
data.terminalCode = 'app';
data.channelCode = (this.$route.query.channelCode?this.$route.query.channelCode:this.chaNelCode);
data.activityId = (this.$route.query.ActCode?this.$route.query.ActCode:'');
}
this.$https.post(this.BASE_URL+"cfs/zc/z008/save",data,
{
headers: {
'Authorization': this.$route.params.zctoken

}
}
)
.then(res => {

if(res.data.status == 200){
this.orderno = res.data.result.orderno;

if(this.$route.params.isDt == 'isDt') {
this.dTDonate()
}else {
this.pay(this.orderno)
}
}else {
this.showToast('','text',res.data.message,'20em','','')
}
})
},
dTDonate() {
let data = {
groupdonationId:this.$route.params.dtId,
crowdfundingId: this.$route.params.id,
ptsOrderId: this.orderno,
creatorId: this.$route.params.epId,
donateNum:this.submitMonet,
userId: this.$route.params.zcuserid,
nickName: this.$route.params.zcnickname
}
this.$https.post(this.BASE_URL+"grd/groupDonation/createDonate",
data
)
.then(res => {
if(res.data.code == 'GRD-APII0000') {
this.pay(this.orderno)
}
})
.catch(function(err) {

})
},
pay (orderno) {






if(this.isWeixinCient()){

let data = {
userId:this.$route.params.zcuserid,

payOrderId:orderno,
totalFee:this.submitMonet,
productInfo:decodeURIComponent(this.$route.params.acr002),
sign:"123456",
busType:'zc',
payType:'wx_pub',
mchType:this.mchTypeH5,
openid:localStorage.getItem('zcopenid')
}
this.$https.post(this.BASE_URL+"cfs/v1/pay",data).then(res => {

if(res.data.code == "CFSPTSI0000"){

this.onBridgeReady(res.data.data,orderno);
}else{
this.showToast('','text','重新再试试！！','20em','','')
}
})
}else{

var sceneInfo='{"h5_info": {"type":"Wap","wap_url": "https://www.zgshfp.com.cn","wap_name": "社会帮扶"}}';
let data = {
userId:this.$route.params.zcuserid,
payOrderId:orderno,
totalFee:this.submitMonet,
productInfo:decodeURIComponent(this.$route.params.acr002),
sign:"123456",
busType:"zc",
payType:'wx_wap',
mchType:this.mchTypeH5,  //帮一把测试环境
sceneInfo:sceneInfo,
}
if(this.$route.params.zctoken=='null'|| this.$route.params.zctoken == undefined || this.$route.params.zctoken == 'undefined' || this.$route.params.zctoken == '' || this.$route.params.zctoken == null){
data.userId=this.noLoginUserId;
this.$https.post(this.BASE_URL+"cfs/v1/pay",data).then(res => {

if(res.data.code == "CFSPTSI0000"){
this.AppGopay(res.data.data,'1');

}else{
this.showToast('','text','重新再试试！！','20em','','');
}
})
}else{
this.$https.post(this.BASE_URL+"cfs/v1/pay",data,
{
headers: {
'Authorization': this.$route.params.zctoken
}
}
)
.then(res => {

if(res.data.code == "CFSPTSI0000"){
this.AppGopay(res.data.data,'2');
/*if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
window.location.href= res.data.data.payMap.mweb_url+'&redirect_url='+ encodeURI(this.appjump_url+'/pages/index/returnappzc.html');
}else {  //判断Android
window.location.href= res.data.data.payMap.mweb_url;
}*/
}else{
this.showToast('','text','重新再试试！！','20em','','');
}
})
}
}
},
AppGopay(data,state){
var ua = window.navigator.userAgent;
console.log(ua);

var isTxNews = ua.match(/qqnews\/([\.\d]+)/i);

var isYlxd = /ulxdapp/.test(navigator.userAgent.toLowerCase());

var isSunland = ua.match(/sunland/i);

var isLiePinAndroid = (ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1) && ua.indexOf('android-tongdao-app') > -1;
var isLiePinIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) && ua.indexOf('ios-tongdao-app') > -1;
var isLiePin = isLiePinAndroid || isLiePinIos;

if((isTxNews&&isTxNews[1])||isYlxd||isSunland||isLiePinAndroid){

this.setItemsforAndriod(data);
if(state == '1'){
this.L('queryZcUserid',this.noLoginUserId)
this.L('queryNickname',this.noLoginUserName)
this.L('queryZcToken','null')

window.location.href= data.payMap.mweb_url+'&redirect_url='+ encodeURIComponent(this.appjump_url+'/pages/index/index.html#/zcprojectDetail/'+this.$route.params.id+'/'+this.noLoginUserId+'/'+this.noLoginUserName+'/null'+'?histroy=back'+this.ActChannel_strs_a);
}else if (state == '2') {
console.log('Android已登录支付完成::::'+this.$route.params.zctoken)
this.L('queryZcUserid',this.$route.params.zcuserid)
this.L('queryNickname',this.$route.params.zcnickname)
this.L('queryZcToken',this.$route.params.zctoken)
window.location.href= data.payMap.mweb_url+'&redirect_url='+ encodeURIComponent(this.appjump_url+'/pages/index/index.html#/zcprojectDetail/'+this.$route.params.id+'/'+this.$route.params.zcuserid+'/'+this.$route.params.zcnickname+'/'+this.$route.params.zctoken+'?histroy=back'+this.ActChannel_strs_a);
}
}else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
if(state == '1'){       //未登录
var querys = '?queryAcr002='+decodeURIComponent(this.$route.params.acr002)+'&queryTimeNow='+this.GtimeNow()+'&queryId='+this.$route.params.id+'&queryZcUserid='+this.noLoginUserId+'&queryZcToken='+this.$route.params.zctoken+'&queryNickname='+this.noLoginUserName+'&querySubmitMoney='+this.submitMonet+'&queryFoundation='+this.$route.params.foundation+'&queryOrderno='+this.orderno
window.location.href= data.payMap.mweb_url+'&redirect_url='+ encodeURIComponent(this.appjump_url+'/pages/index/returnappzc.html'+querys+'&state='+state+this.ActChannel_strs_a);
}else if(state == '2') {                  //已登录
console.log('IOS已登录支付完成::::'+this.$route.params.zctoken)
var querys = '?queryAcr002='+decodeURIComponent(this.$route.params.acr002)+'&queryTimeNow='+this.GtimeNow()+'&queryId='+this.$route.params.id+'&queryZcUserid='+this.$route.params.zcuserid+'&queryZcToken='+this.$route.params.zctoken+'&queryNickname='+this.$route.params.zcnickname+'&querySubmitMoney='+this.submitMonet+'&queryFoundation='+this.$route.params.foundation+'&queryOrderno='+this.orderno;
window.location.href= data.payMap.mweb_url+'&redirect_url='+ encodeURIComponent(this.appjump_url+'/pages/index/returnappzc.html'+querys+'&state='+state+'&fromHelpList='+this.fromHelpList+this.ActChannel_strs_a);
}
}else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
this.setItemsforAndriod(data);
if(state == '1'){
this.L('queryZcUserid',this.noLoginUserId)
this.L('queryNickname',this.noLoginUserName)
this.L('queryZcToken','null')
window.location.href= data.payMap.mweb_url+'&redirect_url='+ encodeURIComponent(this.appjump_url+'/pages/index/index.html#/zcprojectDetail/'+this.$route.params.id+'/'+this.noLoginUserId+'/'+this.noLoginUserName+'/null'+'?histroy=back'+this.ActChannel_strs_a);
}else if (state == '2') {
console.log('Android已登录支付完成::::'+this.$route.params.zctoken)
this.L('queryZcUserid',this.$route.params.zcuserid)
this.L('queryNickname',this.$route.params.zcnickname)
this.L('queryZcToken',this.$route.params.zctoken)
window.location.href= data.payMap.mweb_url+'&redirect_url='+ encodeURIComponent(this.appjump_url+'/pages/index/index.html#/zcprojectDetail/'+this.$route.params.id+'/'+this.$route.params.zcuserid+'/'+this.$route.params.zcnickname+'/'+this.$route.params.zctoken+'?histroy=back'+this.ActChannel_strs_a);
}
}
},
setItemsforAndriod(data){
this.L('anlpbaFlag','1')  
this.L('queryAcr002',decodeURIComponent(this.$route.params.acr002))
this.L('queryTimeNow',this.GtimeNow())
this.L('queryId',this.$route.params.id)



this.L('querySubmitMoney',this.submitMonet)
this.L('queryFoundation',this.$route.params.foundation)
this.L('queryOrderno',this.orderno)
},
onBridgeReady(data,orderno){   //微信支付
let that = this;
WeixinJSBridge.invoke(
'getBrandWCPayRequest', {
"appId":data.payMap.appId,     //公众号名称，由商户传入
"timeStamp":data.payMap.timeStamp,//时间戳，自1970年以来的秒数
"nonceStr":data.payMap.nonceStr, //随机串
"package":data.payMap.package,
"signType":data.payMap.signType,//微信签名方式：
"paySign":data.payMap.paySign //微信签名
},
function(res){
if(res.err_msg == "get_brand_wcpay_request:ok" ) {










that.$router.push('/zccertificateTrain/'+decodeURIComponent(that.$route.params.acr002)+'/'+that.Gtime(parseInt(data.payMap.timeStamp+'000'),'-','-','-').substring(0,10)+'/'+that.$route.params.id+'/'+that.$route.params.zcuserid+'/'+that.$route.params.zctoken+'/'+that.$route.params.zcnickname+'/'+that.submitMonet+'/'+that.$route.params.foundation+'/'+orderno+that.ActChannel_strs_w)








}// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
if(res.err_msg == "get_brand_wcpay_request:fail"||res.err_msg == "get_brand_wcpay_request:cancel"){
that.showToast('','text','支付未完成','20em','','')
}
}
);
}
},
watch: {
inputMoney (val) {
if (val !== '') {
for (var i = 0; i < this.navList.length; i++) {
this.navList[i].isActive = false;
}
this.inputMoney = val;
this.submitMonet = val;
}
}
}
}



// WEBPACK FOOTER //
// ./src/crowd_fund/helpHe.vue